import * as React from 'react';
import { Redirect } from 'react-router';
import { APP_CONSTANTS } from '../common/constants';

const requireAuth = <P extends object>(ComposedComponent: React.ComponentType<P>, isAuthenticated: boolean, IsReadyToRedirect: boolean) => props => {
   return (isAuthenticated) ? <ComposedComponent {...props} /> : IsReadyToRedirect && <Redirect to={APP_CONSTANTS.LINKS.LOGIN} />;
};

export default requireAuth;
